import { render, staticRenderFns } from "./PitchSlide.vue?vue&type=template&id=72dbed0c"
import script from "./PitchSlide.vue?vue&type=script&lang=js"
export * from "./PitchSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72dbed0c')) {
      api.createRecord('72dbed0c', component.options)
    } else {
      api.reload('72dbed0c', component.options)
    }
    module.hot.accept("./PitchSlide.vue?vue&type=template&id=72dbed0c", function () {
      api.rerender('72dbed0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/PitchSlide.vue"
export default component.exports